// extracted by mini-css-extract-plugin
export default {"root":"Connected_root__KnKiE","token_bal":"Connected_token_bal__KP2x6","matic_bal":"Connected_matic_bal__55X52"};